// extracted by mini-css-extract-plugin
module.exports = {"sliderContainer":"VolumeSlider_sliderContainer__U50oZ"};